import type { PresentationPreview } from 'paintscout'

/**
 * Let a device-preview iframe hand its scroll on to the page that holds it (#25118).
 *
 * `@paintscout/ui`'s theme sets `html { overscroll-behavior-y: contain }` through CssBaseline,
 * and the preview renders that CssBaseline inside the frame. That stops the browser's normal
 * scroll chaining: at 100% zoom the 1024px iPad frame is taller than a laptop screen, and a user
 * scrolling inside it reached the frame's bottom while the editor page never moved, so the rest
 * of the frame looked cut off. An inline style beats the stylesheet rule.
 *
 * Only the framed device previews get this. Without a `preview` the frame fills the full-screen
 * Preview/Accept dialog, where there is nothing behind it worth scrolling.
 */
export function allowFrameScrollChaining(doc: Document, preview?: PresentationPreview) {
  if (!preview || preview === 'none') {
    return
  }
  doc.documentElement.style.overscrollBehaviorY = 'auto'
}
